import {Events, ServerMethod} from "./constant";
import {Vue} from "ui.vue";

export let popupMixin = {
	data() {
		return {
			popupComponentActive: false,
			popupComponents: [
				{
					component: "PopupAdditionalProduct",
					visible: false,
					params: {}
				},
				{
					component: "PopupBullets",
					visible: false,
					params: {}
				},
				{
					component: "PopupChangeDeliveryTime",
					visible: false,
					params: {}
				},
			],
		}
	},
	computed: {
		nextPopup() {
			let index = this.popupComponents.findIndex((item) => {
				return item.component == this.popupComponentActive.component;
			});

			index++;

			return (index < this.popupComponents.length) ? this.popupComponents[index] : false;
		}
	},
	methods: {
		setVisiblePopup(popupComponent, visible = false, params = {}) {
			let index = this.popupComponents.findIndex((item) => {
				return item.component == popupComponent;
			});

			if (index < 0) {
				return;
			}

			this.popupComponents[index].visible = visible;

			if (!visible) {

				/**
				 * Если текущий открытый попап надо закрыть переходим дальше
				 */
				if (this.popupComponentActive.component == popupComponent) {
					this.onNextPopup();
				}

				return;
			}

			this.popupComponents[index].params = params;

			if (!this.popupComponentActive) {
				this.popupComponentActive = this.popupComponents[index];
			}

			if (this.$refs.hasOwnProperty("popupModal")) {
				this.$refs.popupModal.openModal();
			}
		},
		onNextPopup() {
			if (this.nextPopup && this.nextPopup.visible) {
				this.popupComponentActive = this.nextPopup;
			} else {
				this.popupComponentActive = false;
				this.closePopup();
			}
		},
		closePopup() {
			console.log("close popup");
			if (this.$refs.hasOwnProperty("popupModal")) {
				this.$refs.popupModal.closeModal();
			}
		},
		onChangeBasketAndDeliveryDate(params) {
			let index = this.popupComponents.findIndex((item) => {
				return item.component == 'PopupChangeDeliveryTime';
			});
			this.popupComponents[index].params.loading = true;


			// установить выбранное дату время this.warningDateTime
			// выставлять "Выбрать дату и время";
			this.setPropertyValue("select_time", "DELIVERY_TIME", "CODE");
			this.setPropertyValue(params.deliveryDateTime, "PICKUP_TIME", "CODE");
			this.onChangeDeliveryTime();
			this.canSetDeliveryTime = true;

			let obProperty = this.getProperty("PICKUP_TIME", "CODE");
			this.changePropertyUserData(obProperty.ID, params.deliveryDateTime);
			this.saveDeliveryTimeCookie(null, params.deliveryDateTime);

			// изменить состав корзины
			this.$store.dispatch("basket/changeItems", params.products).then(() => {


				this.setPropertyValue("select_time", "DELIVERY_TIME", "CODE");
				this.setPropertyValue(params.deliveryDateTime, "PICKUP_TIME", "CODE");
				this.onChangeDeliveryTime();
				this.canSetDeliveryTime = true;

				let obProperty = this.getProperty("PICKUP_TIME", "CODE");
				this.changePropertyUserData(obProperty.ID, params.deliveryDateTime);
				this.saveDeliveryTimeCookie(null, params.deliveryDateTime);

				//this.onSelectDate(obProperty.ID, params.deliveryDateTime);
				Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REFRESH});

				this.popupComponents[index].params.loading = false;

				this.onNextPopup();
			})
		},
		onChangeDeliveryDateInternal(params, isFromPopup = true) {
			// установить выбранное дату время
			// установить тип выбранного времени
			this.setPropertyValue(params.deliveryDateTypeTime, "DELIVERY_TIME", "CODE");
			this.setPropertyValue(params.deliveryDateTime, "PICKUP_TIME", "CODE");
			this.onChangeDeliveryTime();
			this.canSetDeliveryTime = (params.deliveryDateTypeTime === "select_time");

			let obProperty = this.getProperty("PICKUP_TIME", "CODE");
			this.changePropertyUserData(obProperty.ID, params.deliveryDateTime);
			this.saveDeliveryTimeCookie(null, params.deliveryDateTime);

			if (isFromPopup) {
				this.onNextPopup();
			}
		}
	}
}

export default popupMixin;
